export const READING_REASON_CODES = {
  SELECTED_BY_ANALYZER: 'SELECTED_BY_ANALYZER',
  TOO_EARLY: 'TOO_EARLY',
  TOO_LATE: 'TOO_LATE',
  DUPLICATE: 'DUPLICATE',
  OUT_OF_WINDOW_BEFORE_START: 'OUT_OF_WINDOW_BEFORE_START',
  OUT_OF_WINDOW_AFTER_END: 'OUT_OF_WINDOW_AFTER_END',
  NO_CHECKPOINT_MATCH: 'NO_CHECKPOINT_MATCH',
  MANUALLY_OVERRIDDEN: 'MANUALLY_OVERRIDDEN',
  VIRTUAL_READING: 'VIRTUAL_READING',
  MANUALLY_SET_TIME: 'MANUALLY_SET_TIME',
  FILTERED_OUT: 'FILTERED_OUT',
}

const READING_REASON_LABELS_RU = {
  [READING_REASON_CODES.SELECTED_BY_ANALYZER]: 'Выбрано анализатором',
  [READING_REASON_CODES.TOO_EARLY]: 'Слишком рано',
  [READING_REASON_CODES.TOO_LATE]: 'Слишком поздно',
  [READING_REASON_CODES.DUPLICATE]: 'Дубликат считывания',
  [READING_REASON_CODES.OUT_OF_WINDOW_BEFORE_START]: 'Считывание до времени старта участника',
  [READING_REASON_CODES.OUT_OF_WINDOW_AFTER_END]: 'Считывание после времени финиша/конца окна участника',
  [READING_REASON_CODES.NO_CHECKPOINT_MATCH]: 'Не подошло ни под один чекпоинт по правилам назначения',
  [READING_REASON_CODES.MANUALLY_OVERRIDDEN]: 'Переопределено вручную',
  [READING_REASON_CODES.VIRTUAL_READING]: 'Виртуальное считывание',
  [READING_REASON_CODES.MANUALLY_SET_TIME]: 'Время введено вручную',
  [READING_REASON_CODES.FILTERED_OUT]: 'Отсеяно по ограничению',
}

export function translateReasonCode(reasonCode, fallbackReason = '') {
  const code = String(reasonCode || '').trim()
  if (!code) return fallbackReason || ''
  return READING_REASON_LABELS_RU[code] || fallbackReason || code
}

/**
 * Backend may send timelineReasonDetails in English; normalize to Russian for UI.
 * Already-Russian strings are returned as-is.
 */
export function translateTimelineDetailsToRu(details) {
  const s = String(details || '').trim()
  if (!s) return ''
  if (/[а-яА-ЯёЁ]/.test(s)) return s

  const exact = {
    'Reading is before participant start time': 'Считывание раньше времени старта участника.',
    'Reading is after participant finish/end time': 'Считывание позже времени финиша или конца окна участника.',
    'Skipped as exact duplicate by deduplication key': 'Пропущено как дубликат по ключу дедупликации.',
    'Matched by chip, but did not fit any checkpoint slot/rules':
      'Чип распознан, но считывание не подошло ни под одно правило назначения чекпоинта.',
  }
  if (exact[s]) return exact[s]

  let m = s.match(/^Too early for checkpoint\s+(.+)$/i)
  if (m) return `Слишком рано для точки «${m[1]}».`

  m = s.match(/^Too late for checkpoint\s+(.+)$/i)
  if (m) return `Слишком поздно для точки «${m[1]}».`

  m = s.match(/^Selected for checkpoint\s+(.+)$/i)
  if (m) return `Выбрано анализатором для точки «${m[1]}».`

  m = s.match(/^Duplicate at filled checkpoint\s+(.+)$/i)
  if (m) return `Дубликат на уже заполненной точке «${m[1]}».`

  m = s.match(/^Selected by earlier replacement rule for checkpoint\s+(.+)$/i)
  if (m) return `Выбрано правилом замены более раннего времени для точки «${m[1]}».`

  return ''
}
